// extracted by mini-css-extract-plugin
export var root = "N_ww";
export var wrapper = "N_qk";
export var image = "N_wx d_w d_y d_W";
export var imageWithHeight = "N_wy";
export var crop = "N_wz";
export var round = "N_wB";
export var fixedHeight = "N_wC";